import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/profile', [
    {
      path: '',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      redirect: { name: 'profile-details' },
      children: [
        {
          path: 'details',
          name: 'profile-details',
          component: () => import('@/components/profile/ProfileDetails.vue'),
        },
        {
          path: 'email',
          name: 'profile-email',
          component: () => import('@/components/profile/ProfileEmail.vue'),
        },
        {
          path: 'password',
          name: 'profile-password',
          component: () => import('@/components/profile/ProfilePassword.vue'),
        },
      ],
    },
  ]);
};
